<template>
  <div>
    <h4 v-if="!hideTitle"> {{'leads.details.hearing_test' | translate }} </h4>
    <template :headerText="hideTitle ? '' : $t('leads.details.hearing_test')">
      <div v-if="ht">
        <div class="col-md-6" v-if="showAverage">
          <div class="tile">
            <span class="is-bold">{{'leads.details.left' | translate }}:</span> {{ ht.hl_left }} dB HL
          </div>
          <div class="tile">
            <span class="is-bold">{{'leads.details.right' | translate }}:</span> {{ ht.hl_right }} dB HL
          </div>
        </div>
        <div class="col-md-6" v-if="showAverage">
          <h6>{{ 'leads.details.result' | translate }} {{ht.hl_result !== null && ht.hl_result !== '' ? (ht.hl_result === 0 ? $t('leads.details.ht_web.without_hearing_loss') : $t('leads.details.ht_web.with_hearing_loss')) : ''}}</h6>
        </div>
        <div class="col-md-12">
          <va-chart :data="htData" type="line" :options="graphOptions" style="height: 220px;"></va-chart>
        </div>
      </div>
      <div v-else>
        {{'leads.details.no_result' | translate }}
      </div>
    </template>
  </div>
</template>
<script>
import HearingTestGraphOptionsMixin from '@/mixins/HearingTestGraphOptionsMixin'
export default {
  props: {
    hideTitle: {
      type: Boolean,
      required: false,
      default: false
    },
    ht: {
      type: Object,
      required: true
    },
    showAverage: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  mixins: [
    HearingTestGraphOptionsMixin
  ],
  data () {
    return {
      htValues: {
        frequencies: [],
        right: [],
        left: []
      }
    }
  },
  methods: {
    updateResults: function (resultsString) {
      let rows = resultsString.split('\n')
      let frequencies = rows[0].split('\t')
      frequencies.splice(0, 1)

      this.htValues.frequencies.splice(0, this.htValues.frequencies.length, ...frequencies)

      rows.splice(0, 1) // remove line with frequencies
      for (let row of rows) {
        let cols = row.split('\t')
        let side = cols[0]
        cols.splice(0, 1)
        let values = []
        if (side === 'L') {
          values = cols.map(function (item) {
            return -1 * parseInt(item, 10)
          })
          this.htValues.left.splice(0, this.htValues.left.length, ...values)
        } else {
          values = cols.map(function (item) {
            return -1 * parseInt(item, 10)
          })
          this.htValues.right.splice(0, this.htValues.right.length, ...values)
        }
      }
    }
  },
  computed: {
    htData: function () {
      let data = {
        labels: this.htValues.frequencies
      }
      data.datasets = [
        {
          data: this.htValues.left,
          label: this.$t('leads.details.left'),
          borderColor: '#0000ff',
          lineTension: 0,
          backgroundColor: '#0000ff20',
          // backgroundColor: 'rgba(0, 0, 0, 0)',
          pointRadius: 9,
          pointHoverRadius: 10,
          pointBorderWidth: 3,
          pointHoverBorderWidth: 3,
          pointBackgroundColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointStyle: 'crossRot',
        },
        {
          data: this.htValues.right,
          label: this.$t('leads.details.right'),
          borderColor: '#ff0000',
          lineTension: 0,
          backgroundColor: '#ff000018',
          // backgroundColor: 'rgba(0, 0, 0, 0)',
          pointRadius: 8,
          pointHoverRadius: 9,
          pointBorderWidth: 2,
          pointHoverBorderWidth: 3,
          pointBackgroundColor: '#ffe7e7',
          pointHoverBackgroundColor: '#ffe7e7',
          // pointBackgroundColor: 'rgb(255, 255, 255)',
          // pointHoverBackgroundColor: 'rgb(255, 255, 255)',
          pointStyle: 'circle',
        },
      ]
      return data
    },
    activeHearingTest: function () {
      if (this.ht) {
        return this.ht.id
      }
    }
  },
  watch: {
    activeHearingTest: {
      immediate: true,
      handler (value) {
        if (this.ht) {
          this.updateResults(this.ht.result)
        }
      }
    }
  }
}
</script>
